import { WorkflowStateActionType } from '@/types/workflow-state-actions'

/**
 * Whether an action type is available to the current user, per the Firebase
 * Remote Config flag pixydocs-api names on it. An action type with no
 * `feature_flag` is always available; a flag the provider has no value for
 * counts as off, so a gated action type stays hidden until the flag exists.
 *
 * The api serves gated action types to every client, so this is the only place
 * the gate is applied.
 */
export function isActionTypeFlagEnabled(
  actionType: Pick<WorkflowStateActionType, 'feature_flag'>,
  featureFlags: Record<string, boolean>,
): boolean {
  if (!actionType.feature_flag) return true
  return !!featureFlags[actionType.feature_flag]
}
